var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeDownFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.373,
    height: 37.927,
    viewBox: "0 0 24.373 37.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10",
    "data-name": "\\u8DEF\\u5F84 10",
    d: "M3592.158,650.62q0,8.668-.012,17.336a2.043,2.043,0,0,1-.29,1.074,1.3,1.3,0,0,1-1.987.161c-1.408-1.118-2.808-2.246-4.212-3.369q-4.288-3.431-8.585-6.854a1.176,1.176,0,0,0-.674-.233c-1.891-.019-3.782-.009-5.673-.011a2.715,2.715,0,0,1-2.938-2.94q0-5.2,0-10.394a2.705,2.705,0,0,1,2.892-2.905c1.891-.007,3.782.008,5.673-.013a1.3,1.3,0,0,0,.745-.254q6.332-5.037,12.641-10.1a1.493,1.493,0,0,1,1.451-.412,1.33,1.33,0,0,1,.964,1.223c.008.158,0,.317,0,.476Z",
    transform: "translate(-3567.786 -631.644)",
    fill: "#027fa4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeDownFilled);
export default __webpack_public_path__ + "static/media/volume_down_filled.53e22aa13455a8fa07d589222fb864b1.svg";
export { ForwardRef as ReactComponent };